module.exports = __webpack_public_path__ + "img/cliente5.00d6e288.png";